import React from 'react';
import TypingTester from "../../../TypingTester";
import BaseField, {BaseFieldSelfProps} from "./BaseField";

export default class FieldText extends BaseField<any, any> {
    tester: TypingTester;

    constructor(props: BaseFieldSelfProps) {
        super(props)

        this.tester = new TypingTester(250)
        this.state = {
            value: props.value || ''
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: BaseFieldSelfProps) {
        this.setState({
            value: nextProps.value || ''
        })
    }

    onChange = (e: any) => {
        this.setState({value: e.target.value})

        // !!! Do not touch this !!!
        // !!! Store must be updated even if we're not done typing, yet !!!
        this.updateStoreValue(e.target.value)

        this.tester.record(() => {
            this.props.onChange(this.state.value)
        })
    }

    renderReadOnly = () => {
        return <div className="text-field--readonly">{this.state.value} {this.props.unitLabel && (
            <span className={`unit-label--readonly`}>{this.props.unitLabel}</span>)}</div>
    }

    renderTextInput() {
        let id = this.generateUniqueId()
        return (
            <div className="text-field w-100" style={{position: 'relative'}}>
                {this.props.readonly
                    ? this.renderReadOnly()
                    : <input
                        id={id}
                        type="text"
                        value={this.state.value}
                        onChange={this.onChange}
                        readOnly={this.props.readonly}
                    />
                }
            </div>
        )
    }

    renderField() {
        return (
            <div className={this.getClassNames()}>
                <div className="step-input-field">
                    {this.renderLabel() && <div className="label">
                        {this.getLabel()}
                    </div>}
                    <div className="input">
                        <div className="common-input-wrapper">
                            {this.renderTextInput()}
                        </div>
                    </div>
                    {this.renderDescription()}
                    {this.state.errorMessage}
                </div>
            </div>
        )
    }
}